import {
  formatDate,
  formatPhoneNumber,
  formatPhoneNumberToString,
  formatDateFromUTC,
  formatDateDate
} from "./format";

import {
  get,
  set
} from "./session";

export default {
  install(app: any) {
    app.config.globalProperties.$filters = {
      formatDate,
      formatDateFromUTC,
      formatPhoneNumberToString,
      formatPhoneNumber,
      formatDateDate
    };
    app.config.globalProperties.$session = {
      get,
      set
    };
  },
};
